import dayjs from 'dayjs';

export const getFormattedDate = (
  value?: Date | string | number,
  format = 'MM/DD/YYYY',
) => {
  if (!value) return;

  return dayjs(value).format(format);
};
